import React from "react";
import styled from "@emotion/styled";
// import ScatterText from "../firstpage/home";

interface Props {}

export const MyProject: React.FC<Props> = (props) => {
  return (
    <MyProjectContainer>
      testtestse
      <Descrip>
        {/* <ScatterText
          text="Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole."
        /> */}
      </Descrip>
      <Descrip>
        Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.Currently, I am interested in various fields such as AI, IoT,
        Networking, Big Data, and Web Development. Most of my experience so far
        has been in image processing and developing web applications. I also
        have a solid understanding of IoT through past projects and studies. At
        present, I am focusing on studying image processing in depth, including
        the detailed workflow of models and fine-tuning parameters to improve
        performance. In parallel, I am also exploring Large Language Models
        (LLMs), as I aim to build a more comprehensive understanding of AI as a
        whole.
      </Descrip>
    </MyProjectContainer>
  );
};

const MyProjectContainer = styled("div")({
  // position: "relative",
  // // border: "2px solid",
  // // backgroundColor: "black",
  // height: "80vh",
  // justifyItems: "center",
  // paddingTop: "40px",
});

const Descrip = styled("div")({
  fontFamily: '"VT323", monospace',
  fontSize: "26px",
  // top: "30%",
  // display: "flex",
  // position: "relative",
  // justifyItems: "center",
  // justifyContent: "center",
  // textAlign: "center",
  // alignItems: "center",
  // alignContent: "center",
  // width: "800px",
});
